import type {
  BuildSessionReportInput,
  SessionReportDashboard,
  SessionReportHealth,
  SessionReportSummary,
} from "./types";
import {
  buildAudioCard,
  buildBufferingCard,
  buildConnectionCard,
  buildNetworkCard,
  buildRecoveryCard,
  buildSummaryMetrics,
  buildTranscriptCard,
  resolveLatestReportStatus,
  resolveMetricsSnapshot,
} from "./summary";

export const deriveSessionReportDashboard = (
  input: BuildSessionReportInput,
  summary: SessionReportSummary,
  health: SessionReportHealth
): SessionReportDashboard => {
  const latestStatus = resolveLatestReportStatus(input);
  const transcriptCard = buildTranscriptCard(health.transcriptUi, summary);
  const connectionCard = buildConnectionCard(health.connection, latestStatus);
  const recoveryCard = buildRecoveryCard(health.recovery, summary, latestStatus);
  const bufferingCard = buildBufferingCard(health.buffering, summary, latestStatus);
  const networkCard = buildNetworkCard(health.browserNetwork, summary, input);
  const audioCard = buildAudioCard(
    health.audioCapture,
    resolveMetricsSnapshot(input)
  );

  return {
    heroStats: buildSummaryMetrics(summary),
    cards: {
      transcript: transcriptCard,
      connection: connectionCard,
      recovery: recoveryCard,
      buffering: bufferingCard,
      network: networkCard,
      audio: audioCard,
    },
  };
};
